"use strict";
var list = document.querySelector("ul");
/** перетворюємо на число */ function parseSalary(salaryStr) {
    return Number(salaryStr.replace(/\$|,/g, ""));
}
/** сортуємо зп від більшого до меншого */ function sortList(listElement) {
    var items = Array.from(listElement.querySelectorAll("li"));
    items.sort(function(a, b) {
        return parseSalary(b.dataset.salary) - parseSalary(a.dataset.salary);
    });
    items.forEach(function(item) {
        return listElement.appendChild(item);
    });
}
/**  масив обʼєктів співробітників */ function getEmployees(listElement) {
    var items = Array.from(listElement.querySelectorAll("li"));
    return items.map(function(item) {
        return {
            name: item.textContent.trim(),
            position: item.dataset.position,
            salary: parseSalary(item.dataset.salary),
            age: Number(item.dataset.age)
        };
    });
}
/** викликаємо обидві функції */ sortList(list);
getEmployees(list);

//# sourceMappingURL=index.960e1505.js.map
